import { Grid } from '../../../primitives/grid/Grid';
import { useLineData } from '../providers/data';
import { jsx as _jsx } from "react/jsx-runtime";
export function LineGrid() {
  const {
    xScale,
    yScale,
    height,
    width
  } = useLineData();
  return /*#__PURE__*/_jsx(Grid, {
    yScale: yScale,
    xScale: xScale,
    width: width,
    height: height
  });
}